import { Text, type TextProps } from '@mantine/core'
import type { FC, ReactNode } from 'react'

type MultiLineTextProps = TextProps & {
  children?: ReactNode
}

const MultiLineText: FC<MultiLineTextProps> = ({ children, ...props }) => {
  return (
    <Text {...props} style={{ whiteSpace: 'pre-wrap' }}>
      {children}
    </Text>
  )
}

export default MultiLineText
